import { FC } from "react";

import { roleIcon, roleLabel } from "./roles";
import { useHomeRole } from "./use-home-role";

import { IconText } from "mds/components/IconText";
import { Listbox, type ListboxOption } from "mds/components/Listbox";
import { GENERAL_EVENT_CATEGORY } from "utils/amplitude";
import { useNavigate } from "utils/routing";
import { type HomeRole, homeUrlForRole } from "utils/urls";

export type RoleSelectProps = {
  className?: string;
  isLoading?: boolean;
};

type RoleListboxOption = ListboxOption & { id: HomeRole };

export const RoleSelect: FC<RoleSelectProps> = ({ className, isLoading }) => {
  const navigate = useNavigate();
  const { currentRole, availableRoles } = useHomeRole();
  const hasChoices = availableRoles.length > 1;

  if (!isLoading && !hasChoices) {
    return (
      <IconText
        className="text-sm font-medium text-black-tint-20"
        iconStart={roleIcon[currentRole]}
        text={roleLabel[currentRole]}
      />
    );
  }

  const rolesForItems = hasChoices ? availableRoles : [currentRole];
  const items: RoleListboxOption[] = rolesForItems.map((role) => ({
    id: role,
    title: roleLabel[role],
    iconStart: roleIcon[role],
  }));

  return (
    <Listbox
      buttonKind="secondary"
      buttonSize="s"
      className={className}
      disabled={isLoading}
      eventName="New user role selected"
      eventProperties={GENERAL_EVENT_CATEGORY}
      eventPropertyKey="newRole"
      items={items}
      openMenuEventName="Switch User role"
      selectedValue={currentRole}
      onSelectionChange={(item) => {
        navigate(homeUrlForRole(item.id));
      }}
    />
  );
};
